import moment from 'moment/moment';
import { FOCUS_PRIORITY_FIELD } from './focusPriority';

// Transforms quiz slide values into API-ready format
export const transformQuizDataForSubmission = (slideValues) => {
  const basicInfo = {
    name: '',
    email: '',
    gender: '',
    day: '',
    month: '',
    year: '',
    height: '',
    weight: '',
    country: '',
  };
  
  const answers = [];
  
  // Extract values from slideValues
  Object.entries(slideValues).forEach(([slideCode, slideData]) => {
    Object.entries(slideData).forEach(([key, data]) => {
      if (key in basicInfo) {
        basicInfo[key] = data.value;
      } else if (key === FOCUS_PRIORITY_FIELD && Array.isArray(data.value)) {
        answers.push({ [FOCUS_PRIORITY_FIELD]: data.value });
      } else if (data.value !== false && data.answerCode != null) {
        answers.push({ [key]: data.answerCode });
      }
    });
  });
  
  // Format birthdate
  const dob = moment(
    `${basicInfo.year}-${basicInfo.month}-${basicInfo.day}`
  ).format('YYYY-MM-DD');
  
  // Return data in required order
  return [
    { name: basicInfo.name },
    { email: basicInfo.email },
    { dob },
    { gender: basicInfo.gender },
    { height: basicInfo.height },
    { weight: basicInfo.weight },
    { country: basicInfo.country },
    ...answers,
  ];
};
